import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQuery } from 'react-query'
import { tsGetAnimalsInContainer } from '../../Typescript/API_Response'
import { AxiosResponse } from 'axios'
import { useAddSampleContext } from '../../Contexts/Modules/SampleModule/AddSampleModule'
import PhpAPI from '../PHP/APIs/PhpAPI'

export function useGetContainerLineInstructions() {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  const { collection, sampleRun } = useAddSampleContext()

  const container_id = (collection as tsGetAnimalsInContainer)?.container
    ?.ContainerID
  const key = sampleRun?.runInfo?.SampleRunID + '-' + container_id

  const item = window.localStorage.getItem(key)

  const path = `/stuart/container/getLineInstructions.php?containerID=${container_id}`
  const lineQuery = useQuery<any, AxiosResponse>(
    ['PhpAPI', path],
    () => PhpAPI.get(whoAmI!, path),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!container_id && !item,
      onSuccess: (data) => {
        if (data?.lines) {
          window.localStorage.setItem(key, JSON.stringify(data.lines))
        }
      },
    },
  )

  let storedlines = []
  try {
    if (item) {
      storedlines = JSON.parse(item)
    }
    return item ?
        { data: storedlines, isLoading: false, isFetching: false }
      : lineQuery
  } catch {
    window.localStorage.setItem(key, JSON.stringify([]))
    return lineQuery
  }
}
